module.exports = __webpack_public_path__ + "h5/img/mfe_22.67fd90f5.jpg";